import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=d45c66f6&scoped=true"
import script from "./Phones.vue?vue&type=script&lang=js"
export * from "./Phones.vue?vue&type=script&lang=js"
import style0 from "./Phones.vue?vue&type=style&index=0&id=d45c66f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45c66f6",
  null
  
)

export default component.exports